import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CatalogService } from '../../catalog.service';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from '@root/shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE,
  CANCEL,
  Banner_deleted } from '@root/app.constant';
import { Observable } from 'rxjs';
import { BlogData, IapData , BannerData, TextData, Card} from '../catalogue-iap-page.model';
import { VideoData } from '../../catalogue-videos/catalogue-video.model';

@Component({
  selector: 'app-catalouge-display-iap-content',
  templateUrl: './catalouge-display-iap-content.component.html',
  styleUrls: ['./catalouge-display-iap-content.component.scss']
})
export class CatalougeDisplayIAPContentComponent implements OnInit {
  data:any[]
  selectedSection:string;
  pageSize: number = DATA_PER_PAGE;
  textData:any
  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() articleDeleteChange: EventEmitter<any> = new EventEmitter<any>();

  public searchText: string; 
  panelMap: { [key: string]: boolean } = {};
  SimilarArticles:any =[]
  constructor(private catalogService:CatalogService, private toastr:ToastrService, private commonDataService:CommonDataService) { }

  ngOnInit() {
  }


getData(section: string, serviceMethod: (section?) => Observable<any>, dataKey: string) {
  this.data = [];
  this.selectedSection = section;

  serviceMethod(section).subscribe(
    (response) => {
      if (response.status === 0) {
        if(dataKey==='Text'){
         this.textData = response.data
        }
        else{
          this.data = response.data[dataKey];
        }
      } else {
        this.toastr.error(response.error.errorMessage);
        this.textData = undefined
      }
    },
    (error) => {
      this.toastr.error(error.errorMessage);
      this.textData = undefined
    }
  );
}

// Usage:
getBanners() {
  this.getData("Banners", this.catalogService.getBanners.bind(this.catalogService), "banners");
}

getVideos() {
  this.getData("Videos", this.catalogService.getVideos.bind(this.catalogService), "videos");
}

getArticles() {
  this.getData("Articles", this.catalogService.getArticles.bind(this.catalogService), "blogs");
}

getInfographics() {
  this.getData("Infographics", this.catalogService.getInfographics.bind(this.catalogService), "infographics");
}
  
  deleteFile = (data) => {
    const obj = { id: data.id };
    const confirmMessage = 'Are you sure want to delete?';
    
    const handleDeletion = (deleteFn, refreshFn) => {
      this.commonDataService
        .confirm(confirmMessage, 'md')
        .then((confirmed) => {
          if (confirmed) {
            deleteFn(obj).subscribe((response) =>
             {
              if (response.status === 0) {
              this.toastr.success(response.message)
              refreshFn()
              this.articleDeleteChange.emit()
              } else {
                this.toastr.error(response.error.errorMessage);
              }
             },
             (error) => {
              this.toastr.error(error.errorMessage);
            }
            
          );
           
          }
        })
        .catch(() => {
          this.toastr.error(CANCEL);
        });
    };
  
    switch (this.selectedSection) {
      case 'Banners':
        handleDeletion(this.catalogService.deleteBanner.bind(this.catalogService), this.getBanners.bind(this));
        break;
      case 'Videos':
        handleDeletion(this.catalogService.deleteVideo.bind(this.catalogService), this.getVideos.bind(this));
        break;
      case 'Infographics':
        handleDeletion(this.catalogService.deleteInfographic.bind(this.catalogService), this.getInfographics.bind(this));
        break;
      case 'Articles':
        handleDeletion(this.catalogService.deleteBlog.bind(this.catalogService), this.getArticles.bind(this));
        break;
        case 'Section1':
          case 'Section2':
          case 'Section3':
          case 'Form':
          case 'Disclaimer':
      handleDeletion(this.catalogService.deleteText.bind(this.catalogService), this.getText.bind(this, this.selectedSection));
      break;

      default:
        this.toastr.error('Invalid section selected.');
    }
  };
  
  viewFile = (path) => {
    window.open(path, '_blank');
  };

  editFile(item){
    if(this.selectedSection === 'Banners'){
      item['subsectionName']= 'Banners'

        item = {
            ...item,
            bannerData: {
                ...new BlogData(),
                bannerImage: item.bannerImage,
                clickableUrl: item.clickableUrl,
                sequence:item.sequence,
                mobbannerImage:item.mobbannerImage,
                mobileBannerImagePath:item.mobileBannerImagePath,
                webBannerImagePath:item.webBannerImagePath
            }
        } as IapData;
      this.editChange.emit(item);
    }
    else if (this.selectedSection === 'Videos'){
      item['subsectionName']= 'Videos'
      item = {
        ...item,
        videoData: {
            ...new VideoData(),
            title: item.title,
            youtubeLink: item.youtubeLink,
            imagePath: item.imagePath,
      
        }
    } as IapData;
      this.editChange.emit(item);
    }
    else if (this.selectedSection === 'Articles'){
      item['subsectionName']= 'Articles'
        item = {
            ...item,
            blogData: {
                ...new BlogData(),
                title: item.title,
                content: item.content,
                imagePath:item.imagePath,
                similarArticles:item.similarArticles
            }
        } as IapData;
      this.editChange.emit(item);
    }
    else if (this.selectedSection === 'Infographics'){
      item['subsectionName']= 'Infographics'
      item = {
        ...item,
        infoData: {
            ...new BlogData(),
            filePath: item.filePath,
            thumbnailPath: item.thumbnailPath,
     
        }
    } as IapData;
      this.editChange.emit(item);
    }
    else if (['Section1', 'Section2', 'Section3', 'Form', 'Disclaimer'].includes(this.selectedSection)) {
      item['subsectionName'] = "Text";
    
      const baseTextData = {
        ...new TextData(),
        title: item.title,
        description: item.description,
        sectionName: item.sectionName
      };
    
      const sectionSpecificData: { [key: string]: any } = {
        Section2: {subSections: item.subSections && item.subSections.length > 0 ? item.subSections : [new Card(), new Card(), new Card()]} ,
        Section3: {subSections: item.subSections && item.subSections.length > 0 ? item.subSections : [new Card(), new Card(), new Card()] },
        Disclaimer: {
          mobile: item.mobile,
          email: item.email,
          disclaimerAdditionalText: item.disclaimerAdditionalText
        }
      };
    
      item = {
        ...item,
        textData: {
          ...baseTextData,
          ...(sectionSpecificData[this.selectedSection] || {})
        }
      } as IapData;
    
      this.editChange.emit(item);
    }
    
  }

  getText(section: string) {
    this.getData(section, this.catalogService.getIapPageTextBySection.bind(this.catalogService, this.catalogService.getIdBySectionName(section)), "Text");
  }
}
